<form [formGroup]="newModuleForm" data-testid="registration-card">
    <form-section [subtitle]="subtitle(1183)">
        <form-item>
            <form-label [label]="subtitle(7494)" [leftSide]="true"></form-label>
            <form-text-input [inputControl]="newModuleNameControl"
                             [placeholder]="subtitle(1184)">
            </form-text-input>
        </form-item>
        <form-item>
            <form-label [label]="subtitle(1185)" [leftSide]="true"></form-label>
            <form-text-input [inputControl]="registerCodeControl"
                             [placeholder]="'01234'">
            </form-text-input>
        </form-item>
        @if(parameters.urlCompany !== 'polypipe'){
            <form-item>
                <form-label [label]="subtitle(5191)" [leftSide]="true"></form-label>
                <form-checkbox [inputControl]="postcodePolicyControl"
                               [disabled]="isPostCodePolicyAccepted()">
                </form-checkbox>
            </form-item>
        }
        @if(isPostCodePolicyAccepted()) {
            <form-item>
                <form-label [label]="subtitle(1929)" [leftSide]="true"></form-label>
                <country-list [inputControl]="countryControl"></country-list>
            </form-item>
            <form-item>
                <form-label [label]="subtitle(1930)" [leftSide]="true"></form-label>
                <form-text-input [inputControl]="zipCodeControl"
                                 [placeholder]="subtitle(1930)">
                </form-text-input>
            </form-item>
        }
        <form-item>
            <form-label [for]="'email'" [label]="subtitle(1110)" [leftSide]="true"></form-label>
            <form-email-input [emailControl]="notificationEmailControl"></form-email-input>
        </form-item>
        <form-item>
            <form-label [label]="subtitle(2972)" [leftSide]="true"></form-label>
            <form-text-input [inputControl]="additionalInformationControl"
                             [placeholder]="subtitle(2972)">>
            </form-text-input>
        </form-item>
        @if (showRecaptcha) {
            <form-item [heightAuto]="true">
                <div class="captcha-box">
                    <re-captcha #captchaRef (resolved)="resolved($event)"
                                [siteKey]="forms.captcha_key">
                    </re-captcha>
                    @if (!views.isRecaptchaReady) {
                        <loader [dark]="true" class="captcha-loader bg-light"></loader>
                    }
                </div>
            </form-item>
        }
        <form-item [flexEnd]="true">
            <form-button [subtitle]="subtitle(1137)"
                         [btnType]="'confirm'"
                         (click)="registerModule()">
            </form-button>
        </form-item>
    </form-section>
</form>

